import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { connectionShape } from "app/lib/shared_prop_types"
import { formatHexColorValue } from "shared/lib/alternate_brand_color"
import ConnectButton from "shared/components/connection_card/connect_button/index"
import parse from "html-react-parser"

import { compactInteger } from "humanize-plus"
import appletOrConnection from "shared/lib/use_applet_or_connection"
import userCountIcon from "images/web/applet_card/user-count-icon.svg"
import { planNameBadge } from "shared/utils/tiers"
import { PausedChipSpace } from "./paused_chip"

import "./small_applet_card.module.scss"

export default class Meta extends Component {
  render() {
    const { appearDisabled, applet, href, mainService, onAppletClick, showConnectButton, isOnboardingApplet, paused } =
      this.props

    const showInstalls = applet.installs_count > 0
    const humanizedInstallNumber = showInstalls && compactInteger(applet.installs_count, 1)
    const installsLabel = showInstalls && `${humanizedInstallNumber} users enabled this ${appletOrConnection(applet)}`
    const isConnected = applet.status === "enabled_for_user"
    // DSL track: Black/300 over the card color.
    const background = applet.background_images?.sm_background_image_url ? "rgba(17, 17, 17, 0.5)" : "rgba(17, 17, 17, 0.3)"
    const handleOnClick = event => {
      event && onAppletClick(event)
      href && window.location.assign(href)
    }
    const needsProBadge = applet.pro_features || applet.intermediate_pro_features

    return (
      <>
        <div className={classnames("meta", { badged: needsProBadge, "onboarding-applet": isOnboardingApplet })}>
          {showInstalls && (
            // role="img" lets the aria-label name the count; a bare div has the generic role, which cannot be named.
            <div
              className="installs"
              role="img"
              aria-label={installsLabel}
              title={installsLabel}
            >
              <span className="verified">
                <img src={userCountIcon} alt="" title={installsLabel} loading="lazy" width="12" height="12" />
              </span>
              <span className="number">{humanizedInstallNumber}</span>
            </div>
          )}
          {needsProBadge && (
            <span title={`Applet has pro features`} className="card-badge">
              {parse(planNameBadge(applet.pro_features ? "Pro+" : "Pro"))}
            </span>
          )}
        </div>
        {showConnectButton && (
          <div className="small-applet-connect-button-wrapper">
            {paused ? (
              <PausedChipSpace />
            ) : (
              <ConnectButton
                smallFlavor
                mainService={mainService}
                onConnectClick={handleOnClick}
                connected={isConnected}
                defaultBgColor={{ background }}
                knobBgColor={{
                  boxShadow: "none",
                  backgroundColor:
                    (isConnected && !appearDisabled) || isOnboardingApplet
                      ? formatHexColorValue(mainService.brand_color)
                      : "#AAA",
                }}
                knobBgColorForDarkBrands={mainService.brand_color.indexOf("000") !== -1}
                connectButtonMaxFontSize={16}
              />
            )}
          </div>
        )}
      </>
    )
  }
}

Meta.propTypes = {
  appearDisabled: PropTypes.bool,
  applet: connectionShape.isRequired,
  href: PropTypes.string,
  isOnboardingApplet: PropTypes.bool,
  mainService: PropTypes.object,
  onAppletClick: PropTypes.func,
  paused: PropTypes.bool,
  showConnectButton: PropTypes.bool,
}

Meta.defaultProps = {
  appearDisabled: false, // the applet appears disabled to show the user they will lose the applet
  isOnboardingApplet: false,
  showConnectButton: true,
}
